import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { GetActivityByStatus } from 'domain/usecases';

interface IDashboardGetActivityByStatus {
  activityByStatus: GetActivityByStatus.Result;
  loadingStatusPageActivityByStatus: boolean;
}

interface IPayloadActivityByStatus
  extends PayloadAction<GetActivityByStatus.Result> {}

const initialState: IDashboardGetActivityByStatus = {
  activityByStatus: null,
  loadingStatusPageActivityByStatus: false,
};

export const ActivityByStatusSlice = createSlice({
  name: 'activity-by-status',
  initialState,
  reducers: {
    loadActivityByStatus: (state, action: IPayloadActivityByStatus) => {
      state.activityByStatus = action.payload;
    },
    clearActivityByStatus: (state) => {
      state.activityByStatus = null;
    },
    loadingStatusPageActivityByStatus: (
      state,
      action: PayloadAction<boolean>,
    ) => {
      state.loadingStatusPageActivityByStatus = action.payload;
    },
  },
});

export const {
  loadActivityByStatus,
  clearActivityByStatus,
  loadingStatusPageActivityByStatus,
} = ActivityByStatusSlice.actions;

export default ActivityByStatusSlice.reducer;
